import { render } from "./CrudOrigen.vue?vue&type=template&id=4841b0dc"
import script from "./CrudOrigen.vue?vue&type=script&lang=js"
export * from "./CrudOrigen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__